module.exports = __webpack_public_path__ + "img/3.7c9c3f01.jpg";